import axios from 'axios'

// Get all show types
const getAll = async () => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/show-type`)
  return data
}

export {
  getAll
}
